import React, { ReactNode } from "react";

import { bem } from "@react-md/utils";
import cn from "classnames";

import InlineButtons from "../InlineButtons";

interface FooterProps {
  caption?: ReactNode;
  className?: string;
  disabled?: boolean;
  editing: boolean;
  labeled?: boolean;
  onCancel?: () => void;
  onSave?: () => void;
}

const block = bem("mmc-inline-input-footer");

const Footer = ({
  caption,
  className,
  disabled,
  editing,
  labeled = true,
  onCancel,
  onSave,
}: FooterProps) => {
  const buttonsVisible = !disabled && editing;
  if (!buttonsVisible && !caption) {
    return null;
  }

  return (
    <div className={cn(block({ labeled }), className)}>
      <div className={block("column")}>
        <div className={block("caption")}>{caption ?? ""}</div>
        {buttonsVisible && <InlineButtons onCancel={onCancel} onSave={onSave} />}
      </div>
    </div>
  );
};

export default Footer;
